const { districtCode: districtId } = require('helper/config');
const Server = require('helper/server');
const { walkNoTextTree } = require('helper/util');
let LastSupplierText = '';

module.exports.searchAgencyAndSupplier = function searchAgencyAndSupplier () {
  this.$content.find('.block__content').spin(); // 搜索前先旋转
  const { code, text, name } = this.selectedTreeNode;
  console.log(this, LastSupplierText , name);
  // 两种情况:代理机构列表、供应商列表
  if (this.rootType.includes('代理机构')) {
    const requestData = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      regDist: code,
      regDistName: name
    };
    // 目录树切换 重置页码
    if (LastSupplierText !== text) {
      requestData.pageNo =1 ;
      requestData.pageSize =15;
      this.pageNo=1;
      this.pageSize=15;
    }
    LastSupplierText = text;
    if (this.query.get('keyword')) {
      requestData.fullName = this.query.get('keyword');
    }
    this.renderAgentList(requestData);
  } else {
    const requestData = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      district: districtId,
      hangupStatus: 0,
      regDistName: name
    };
    switch (text) {
      case '公示中':
        requestData.auditStatus = 'PUBLIC_COMMENT';
        break;
      case '待入库':
        requestData.auditStatus = 'PUBLIC_COMMENT_END';
        break;
      default:
        if (text == '挂起') {
          requestData.hangupStatus = 1;
        }
        if (text == '注册供应商') {
          delete requestData.hangupStatus;
        }
        requestData.status = 'OFFICIAL';
        break;
    }
    // 目录树切换 重置页码
    if (LastSupplierText !== text) {
      requestData.pageNo =1 ;
      requestData.pageSize =15;
      this.pageNo=1;
      this.pageSize=15;
    }
    LastSupplierText = text;
    if (this.query.get('keyword')) {
      requestData.name = this.query.get('keyword');
    }
    this.renderSupplierList(requestData);
  }
};

/**
   * 公告高级搜索
   */
module.exports.advancedSearch = async function advancedSearch () {
  if (!this.$asModal) {
    const payload = {
      queryWithCode: true,
      includeAllNode: false,
      includeSelf: false
    };
    const { data: districtList } = await Server.getAnnouncementDistrict(payload);
    const procurementMethodCode = await Server.queryProcurementMenuMode();
    // const procurementMethodCode = districtList;
    // procurementMethodCode.push({ code: 1, name: '11', children: [{ code: 1, name: 1 }, { code: 2, name: 2 }] });
    const { districtCode, procurementMethodCode: methodCode } = this.query.params;
    // 高级搜索区划默认选中
    if (districtCode) {
      const current = districtList.forEach((item) => {
        if (Array.isArray(districtCode)) {
          districtCode.some((codeItem) => {
            if (item.code.indexOf(codeItem) != -1) {
              item.selected = true;
              return true;
            }
            return false;
          });
        } else if (districtCode.indexOf(item.code) !== -1) {
          item.selected = true;
        }
      });
      current && (current.selected = true);
    }
    if (methodCode) {
      procurementMethodCode.some((item) => {
        if (!item.children || item.children.length <= 0) {
          if (item.code == methodCode) {
            item.selected = true;
            return true;
          }
          return false;
        }
        return item.children.some((child) => {
          if (child.code == methodCode) {
            child.selected = true;
            return true;
          }
          return false;
        });
      });
    }
    let modalData = {
      districtCode: districtList,
      procurementMethodCode,
      keyword: this.query.params.keyword,
      projectName: this.query.params.projectName,
      projectCode: this.query.params.projectCode,
      gpCatalogName: this.query.params.gpCatalogName,
      begin: this.query.params.begin && moment(+this.query.params.begin).format('YYYY-MM-DD'),
      end: this.query.params.end && moment(+this.query.params.end).format('YYYY-MM-DD')
    };
    this.$asModal = ZCY.utils.modal({
      templateUrl: 'templates/notice-as-modal-tpl',
      container: this.$el,
      data: modalData,
      cls: 'as-modal',
      button: ['查询', '重置'],
      cancel: ($modal) => {
        $modal.emptyData();
        this.query.empty();
      },
      confirm: ($modal) => {
        $modal.modal('hide');
        const param = $modal.getData();
        this.query.empty();
        for (let k in param) {
          let val = param[k];
          if (!val) {
            continue;
          }
          k === 'begin' && (val = Date.parse(val) - (8 * 60 * 60 * 1000));
          k === 'end' && (val = Date.parse(val) + ((16 * 60 * 60 * 1000) - 1));
          this.query.set(k, val);
        }
        // sessionStorage.setItem('params', JSON.stringify(this.query.params || {}));
        let searchStr = this.query.toString();

        location.href = `${location.protocol}//${location.host}${location.pathname}${searchStr}`;
        // this.searchEvent({ type: 'as' });
      }
    }).modal;
    this.$asModal.find('.date').datetimepicker({
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      language: 'zh-CN'
    });
    this.selectDistrictCode = this.$asModal.find('[name=districtCode]').selectric({
      multiple: {
        separator: ',',
        keepMenuOpen: true
      }
    }).change((e) => {
      console.log(e);
    });
    this.$asModal.find('[name=procurementMethodCode]').selectric();
    this.$asModal.find('[name=isExact]').selectric();
  } else {
    this.$asModal.modal('show');
  }
};

module.exports.treeData = async function treeData (params = {}) {
  if (this.rootType.includes('代理机构')) {
    const payload = {
      includeAllNode: false,
      agentFlag: 1,
    };
    const { data } = await Server.getDistrictTree(payload);
    // 应为无省本级，修复将最后一位放在第一位的问题
    const lastItem = data.shift();
    data.push(lastItem);
    return walkNoTextTree(data);
  }
  return null;
};
